import { useQuery } from "@tanstack/react-query";
import { LOCATIONS } from "@/data/content";

const API = process.env.REACT_APP_BACKEND_URL;

// Fetches the live truck schedule from the calendar feed.
// Falls back to the static LOCATIONS list when the calendar has no events yet
// (or if the feed is unreachable), so the page is never empty.
export function useSchedule() {
  const { data } = useQuery({
    queryKey: ["truck-schedule"],
    queryFn: async () => {
      const res = await fetch(`${API}/api/schedule`);
      if (!res.ok) throw new Error("Failed to load schedule");
      const json = await res.json();
      return json.stops || [];
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return data && data.length ? data : LOCATIONS;
}
